import PropTypes from "prop-types";
import Text from "shared/components/data-display/mui/Text";
import Close from "shared/components/utils/icons/Close";
import { Container, StyledLink } from "./BreadcrumbChip.styles";

const Breadcrumb = (props) => {
    return (
        <Container>
            <StyledLink {...props}>
                <Text variant="smallLight">
                    {props.children}
                    <Close />
                </Text>
            </StyledLink>
        </Container>
    );
};

Breadcrumb.propTypes = {
    children: PropTypes.node,
};

export default Breadcrumb;
